import React from "react";
import PropTypes from "prop-types";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import HandshakeIcon from "@mui/icons-material/Handshake";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import TuneIcon from "@mui/icons-material/Tune";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import CallEndIcon from "@mui/icons-material/CallEnd";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
import { Box, IconButton, Typography } from "@mui/material";

const leadMetricsData = [
  {
    title: "New Leads",
    icon: <TrendingUpIcon />,
    iconBg: "rgba(255, 105, 180,0.2)",
    iconColor: "#ff69b4",
  },
  {
    title: "Engagement",
    icon: <HandshakeIcon />,
    iconBg: "rgba(3, 168, 158,0.2)",
    iconColor: "#03A89E",
  },
  {
    title: "Drop Off Leads",
    icon: <WaterDropIcon />,
    iconBg: "rgba(252, 169, 3,0.2)",
    iconColor: "#fca903",
  },
  {
    title: "DIY Leads",
    icon: <TuneIcon />,
    iconBg: "rgba(252, 3, 61,0.2)",
    iconColor: "#fc033d",
  },
  {
    title: "Whatsapp Engage",
    icon: <WhatsAppIcon />,
    iconBg: "#25D366",
    iconColor: " #ffffff",
  },
  {
    title: "Total Calls",
    icon: <CallIcon />,
    iconBg: "rgba(54, 162, 235, 0.2)",
    iconColor: "rgb(54, 162, 235)",
  },
  {
    title: "Outbound Calls",
    icon: <PhoneForwardedIcon />,
    iconBg: "rgba(255, 206, 86, 0.2)",
    iconColor: "rgb(255, 206, 86)",
  },
  {
    title: "Inbound Calls",
    icon: <PhoneCallbackIcon />,
    iconBg: "rgba(46, 184, 46, 0.2)",
    iconColor: "rgb(46, 184, 46)",
  },
  {
    title: "Answered Calls",
    icon: <PhoneInTalkIcon />,
    iconBg: "rgb(76, 205, 153, 0.2)",
    iconColor: "rgb(54, 186, 152)",
  },
  {
    title: "Unanswered Calls",
    icon: <CallEndIcon />,
    iconBg: "rgb(231, 111, 81,0.5)",
    iconColor: "rgb(231, 111, 81)",
  },
  {
    title: "Missed Calls",
    icon: <PhoneMissedIcon />,
    iconBg: "rgb(244, 162, 97, 0.5)",
    iconColor: "rgb(244, 162, 97)",
  },
];

export function DashboardCard({ title, data, fromDate, toDate }) {
  const metricData = leadMetricsData.find((metric) => metric.title === title);

  if (!metricData) {
    console.warn(`No matching metric found for title: ${title}`);
    return <Box>No data available for "{title}".</Box>;
  }

  const { icon, iconBg, iconColor } = metricData;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "20px",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        minWidth: "250px",
        maxWidth: "300px",
        maxHeight: {
          xs:70,
          sm:70,
          md:70,
          lg:70,
          xl:80,
        },
        minHeight: {
          xs:60,
          sm:60,
          md:60,
          lg:60,
          xl:80,
        },
        padding: "10px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: "rgba(58, 54, 219, 0.9)",
          cursor: "pointer",
        },
        color: "#111111",
          ":hover":{
            color:"#ffffff"
          }
      }}
      title={`Metric: ${title}, Data: ${data}`}
    >
      <Box
        sx={{
          backgroundColor: iconBg,
          color: iconColor,
          borderRadius: "50%",
          marginRight: "8px",
          height: "40px",
          width: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        aria-label={`Icon for ${title}`}
      >
        {icon}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <h1
          // variant="h1"
          style={{
            fontSize: "18px",
            fontWeight: "600",
            margin: 0,
          }}
        >
          {title}
        </h1>
        <h6
          style={{
            fontSize: "15px",
            fontWeight: "500",
            margin: 0,
          }}
        >
          {data}
        </h6>
      </Box>
    </Box>
  );
}

DashboardCard.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
};
